<div class="w-full p-20 bg-pastel-blue border-box h-full scroll-y">
  <div class="flex gap-20 mb-20">
    <div>
      <img src="assets/cerfa-icon.svg" alt="list">
    </div>
    <div>
      <h3 class="light-blue no-margin text-lg">Scrutin configuré</h3>
      <p class="dark-gray no-margin text-sm">
        La configuration du scrutin est terminée et les paramètres de sécurité ont été validés
      </p>
    </div>
  </div>

  <div class="flex flex-column gap-20 mb-20 bg-white flex flex-column radius-10 align-items-center p-20">

    <img src="assets/ballot-shield-icon.svg" alt="ballot">

    <h1 class="dark-blue no-margin">CONFIGURATION DU SCRUTIN TERMINÉE</h1>

    <div class="bg-light-green radius-10 w-fit p-10 flex gap-10" style="border: solid 1px #D2F8DD;">
      <img src="assets/locker-green.svg" alt="locker">
      <p class="no-margin strong-green">
        Les clefs de scellement ont été envoyées aux assesseurs afin de sceller définitivement le système
      </p>
    </div>

    <div class="flex gap-10">
      <v8te-active-button [buttonText]="'Consulter mon scrutin'" [primaryColor]="'#FFFFFF'"
        [textPrimaryColor]="'#1990FF'" [iconPosition]="'left'" [border]="'solid 1px #1990FF'"
        [height]="'40px'" [minWidth]="'120px'" [width]="'120px'" 
        (click)="toPollPlannedEvent.emit()"></v8te-active-button>

      <!-- <v8te-active-button [buttonText]="'Télécharger le PV de scellement'" [primaryColor]="'#FFFFFF'"
        [textPrimaryColor]="'#1990FF'" [iconPosition]="'left'" [border]="'solid 1px #1990FF'"
        [icon]="'assets/download-icon.svg'" [iconAlt]="'download icon'" [height]="'40px'" [minWidth]="'120px'"
        [width]="'120px'"></v8te-active-button> -->
    </div>
  </div>
</div>